import { FC } from "react"
import InformativeIcon, { InformativeIconItem } from "./InformativeIcon"
import { IconColor } from "@/components/shared/Icon"

interface InformativeIconsProps {
   // variant: Alert
   iconColor: IconColor
   informativeIcons: InformativeIconItem[]
}

const InformativeIcons: FC<InformativeIconsProps> = ({
   // variant,
   iconColor,
   informativeIcons,
}) => {
   // if (variant === Alert.RED || variant === Alert.YELLOW) {
   //    return informativeIcons.map((informativeIcon, index) => (
   //       <InformativeIcon
   //          key={index}
   //          variant={variant}
   //          informativeIconItem={informativeIcon}
   //       />
   //    ))
   // }

   return informativeIcons.map((informativeIcon, index) => (
      <InformativeIcon
         key={index}
         iconColor={iconColor}
         informativeIconItem={informativeIcon}
      />
   ))
}

export default InformativeIcons
